import { Outlet } from "react-router-dom"
import Icon from "../../Components/Icon"
import Text from "../../Components/Text"
const LoginLayout = () => {

    return (
        <div className="flex w-full h-full bg-white overflow-hidden">
            <div className="flex flex-col w-full h-full items-center justify-start overflow-y-auto">
                <div className="flex w-full p-2 gap-4 justify-start items-center">
                    <div className="flex flex-col">
                        <Icon iconName={"small_logo.png"} classNames="w-full" />
                        <Text type="main">Einfach Bestellen. Ohne lästiges Anstehen </Text>
                    </div>          
                </div>
                <Outlet/>
            </div>

            <div className="relative flex-col h-full w-full hidden md:flex text-center items-center justify-center">
                <div className="absolute inset-0 bg-gradient-to-r from-white via-transparent to-transparent z-10 pointer-events-none"></div>
                <Icon iconName={"women_stock.png"} classNames="h-full w-full object-cover" />
            </div>
        </div>
    )
}
export default LoginLayout